"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTextField = void 0;
const text_field_1 = require("../../../components/text-field/text-field");
const form_field_1 = require("./form-field");
exports.FormTextField = form_field_1.formFieldFactory(text_field_1.TextField);
//# sourceMappingURL=form-text-field.js.map